import React, { useCallback, useContext, useEffect, useState } from 'react';
import cx from 'classnames';
import { debounce } from 'lodash';
import classes from './ListComponents.module.scss';
import { DSArrowRightIcon } from '@ds-icons';
import { ListItemContext } from '../useListItemContext';
import Popper, { PopperProps } from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';

export interface SubmenuProps {
  children: React.ReactNode;
  placement?: PopperProps['placement'];
  iconSize?: string;
  offset?: string;
}

const HOVER_DELAY_TIME_MS = 300;

const Submenu = ({
  children,
  placement = 'right-start',
  iconSize = '12px',
  offset = '0'
}: SubmenuProps) => {
  const { itemHovered, listItemRef } = useContext(ListItemContext);
  const [isOpen, setIsOpen] = useState(false);

  const debouncedSetIsOpen = useCallback(
    debounce(hoverState => setIsOpen(hoverState), HOVER_DELAY_TIME_MS),
    []
  );

  useEffect(() => {
    debouncedSetIsOpen(itemHovered);

    return () => {
      debouncedSetIsOpen.cancel();
    };
  }, [itemHovered, debouncedSetIsOpen]);

  return (
    <div className={cx(classes.submenuIconContainer)}>
      <DSArrowRightIcon width={iconSize} height={iconSize} />
      <Popper
        placement={placement}
        open={isOpen}
        anchorEl={listItemRef.current}
        modifiers={{
          offset: {
            enabled: true,
            offset
          }
        }}
        className={cx(classes.submenuPopper)}
      >
        <Paper elevation={0}>{children}</Paper>
      </Popper>
    </div>
  );
};

export default Submenu;
